import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fileUrl } from "../../lib/api";

export function ArtistLineup({ artists = [] }) {
  if (!artists.length) return null;
  return (
    <>
      {/* desktop: expanding panels lined up */}
      <div className="hidden lg:flex h-[74vh] w-full gap-1.5" data-testid="artist-lineup">
        {artists.map((a, i) => (
          <Link
            key={a.slug}
            to={`/artists/${a.slug}`}
            data-testid={`lineup-${a.slug}`}
            className="lineup-panel group relative flex-1 hover:flex-[3.5] overflow-hidden border border-ash bg-charcoal"
          >
            <img
              src={fileUrl(a.photo)}
              alt={a.name}
              loading={i < 6 ? "eager" : "lazy"}
              className="absolute inset-0 w-full h-full object-cover object-top grayscale brightness-110 group-hover:grayscale-0 group-hover:brightness-100 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/25 to-obsidian/45" />

            <span className="absolute top-4 left-0 right-0 text-center font-mono text-[0.6rem] text-white/70 tabular-nums">/{String(i + 1).padStart(2, "0")}</span>

            {/* collapsed: compact centered name */}
            <div className="absolute bottom-6 left-0 right-0 px-1 text-center group-hover:opacity-0 transition-opacity duration-200">
              <span className="block display text-xl xl:text-2xl text-white leading-none truncate">{a.name}</span>
            </div>

            {/* expanded */}
            <div className="absolute bottom-0 left-0 right-0 p-6 opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
              <span className="eyebrow">{a.role}</span>
              <h3 className="display text-4xl xl:text-5xl text-white mt-2 leading-none">{a.name}</h3>
              <p className="text-[#C4C4CC] text-sm mt-2 max-w-xs line-clamp-2">{a.tagline}</p>
              <span className="inline-flex items-center gap-2 mt-4 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-violet">View Artist <ArrowUpRight size={13} /></span>
            </div>
          </Link>
        ))}
      </div>

      {/* mobile: horizontal snap scroll */}
      <div className="lg:hidden flex gap-3 overflow-x-auto snap-x snap-mandatory pb-4 -mx-5 px-5" data-testid="artist-lineup-mobile">
        {artists.map((a, i) => (
          <Link key={a.slug} to={`/artists/${a.slug}`} className="snap-start shrink-0 w-[68vw] relative border border-ash overflow-hidden bg-charcoal">
            <div className="aspect-[3/4] overflow-hidden"><img src={fileUrl(a.photo)} alt={a.name} className="w-full h-full object-cover object-top" /></div>
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent" />
            <div className="absolute bottom-0 p-5">
              <span className="eyebrow">/{String(i + 1).padStart(2, "0")}</span>
              <h3 className="display text-4xl text-white mt-1">{a.name}</h3>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}
